(function () {
  var CLOUD_NAME = 'nmfqqvl5';
  var UPLOAD_PRESET = 'pes_custom_orders';
  var UPLOAD_URL = 'https://api.cloudinary.com/v1_1/' + CLOUD_NAME + '/image/upload';

  function uploadFile(root, file) {
    var hiddenUrlInput = root.querySelector('[data-quote-file-url]');
    var status = root.querySelector('[data-quote-file-status]');
    var preview = root.querySelector('[data-quote-file-preview]');
    var dropzone = root.querySelector('[data-quote-dropzone]');
    if (!file || !hiddenUrlInput) return;

    hiddenUrlInput.value = '';
    if (status) {
      status.textContent = 'Uploading reference image…';
      status.hidden = false;
    }
    if (dropzone) dropzone.classList.add('is-uploading');

    var formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);

    fetch(UPLOAD_URL, { method: 'POST', body: formData })
      .then(function (response) {
        if (!response.ok) throw new Error('Upload failed');
        return response.json();
      })
      .then(function (data) {
        hiddenUrlInput.value = data.secure_url;
        if (status) status.textContent = 'Reference image attached ✓';
        if (preview) {
          preview.src = data.secure_url;
          preview.hidden = false;
        }
      })
      .catch(function () {
        if (status) status.textContent = 'Upload failed — you can still submit without it, or try again.';
      })
      .finally(function () {
        if (dropzone) dropzone.classList.remove('is-uploading');
      });
  }

  function initQuoteUpload(root) {
    var fileInput = root.querySelector('[data-quote-file-input]');
    var dropzone = root.querySelector('[data-quote-dropzone]');
    if (!fileInput) return;

    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      if (file) uploadFile(root, file);
    });

    if (dropzone) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          dropzone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'dragend'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          dropzone.classList.remove('is-dragover');
        });
      });
      dropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.remove('is-dragover');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) uploadFile(root, file);
      });
    }
  }

  document.querySelectorAll('[data-quote-upload-root]').forEach(initQuoteUpload);
})();
